import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CustomContext from './customContext';
import getStringsForLocal from '../../utils/getStringsForLocal';

const CustomProvider = (props) => {
  const { children, locale } = props;

  const value = useMemo(() => {
    const translations = getStringsForLocal({ locale });
    return { translations };
  }, [locale]);

  return (
    <CustomContext.Provider value={value}>
      {children}
    </CustomContext.Provider>
  );
};

CustomProvider.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.element,
};

CustomProvider.defaultProps = {
  locale: 'en-US',
  children: null,
};

export default CustomProvider;
